module.exports = __webpack_public_path__ + "img/central_blitz.10da0032.jpg";